export const END_OF_DAY_LOAD_TARGET_SUSPENSION_CODE = "end_of_day_load_target_suspension_confirmation_required";

// Le Chargé PM sortirait des commandes de la remorque cible : `choose` reçoit "keep", "suspend" ou null (Annuler).
export function buildEndOfDayLoadTargetSuspensionDialog(challenge, choose) {
  const deliveries = Array.isArray(challenge?.suspended_deliveries) ? challenge.suspended_deliveries : [];
  const orderIds = deliveries.map((item) => item?.order_id).filter(Boolean);
  const plural = orderIds.length > 1;
  const subject = plural ? `les commandes ${orderIds.join(", ")}` : `la commande ${orderIds[0] || ""}`;
  const truck = challenge?.truck_label || "la remorque";
  const keepAvailable = challenge?.client_repeat === true;
  const suspend = { label: "Mettre dans Suspendues", onClick: () => choose("suspend") };
  return {
    isOpen: true,
    cornerRadius: "grain",
    contentDensity: "compact",
    eyebrow: "Chargé PM",
    title: keepAvailable ? `Garder ${subject} sur ${truck} ?` : `Mettre ${subject} dans Suspendues ?`,
    description: keepAvailable
      ? `Le Chargé PM est livré en premier le matin : pour livrer aussi ${subject}, ${truck} devra revenir une deuxième fois chez ce client. Pour une seule visite, ${plural ? "mettez-les" : "mettez-la"} ensuite en Chargé PM, ${plural ? "elles" : "elle"} aussi.`
      : `Avec ce Chargé PM, ${truck} ne peut plus livrer ${subject} dans sa journée.`,
    summaryItems: deliveries.map((item) => ({
      label: item?.order_id || "",
      value: [item?.quantity_tons != null ? `${item.quantity_tons} t` : "", item?.client_name || ""].filter(Boolean).join(" · "),
    })),
    confirmLabel: keepAvailable ? "Garder sur la remorque (2 visites)" : suspend.label,
    secondaryAction: keepAvailable ? suspend : null,
    onConfirm: () => choose(keepAvailable ? "keep" : "suspend"),
    onCancel: () => choose(null),
    onClose: () => choose(null),
  };
}
